// 모바일 타임시트 등록/수정 폼 (view/mobile/timesheet/form.html) — Phase G-3(2026-09-18)
//
// 데스크톱 소송 상세 타임시트 탭의 모바일 전체 페이지판. 서버 API 는 데스크톱 것을 그대로 호출한다.
//   POST /suit/api/{cmIdx}/timesheets · PUT/DELETE /suit/api/{cmIdx}/timesheets/{wrSeq}
//   body = { wrGubun3(수행자, 필수), wrSubdate1(업무일 yyyy-MM-dd, 필수), wrInfo1(분 — 빈값은 서버가 '0'), wrContent }
// 단건 GET API 가 없어 수정 프리필은 컨트롤러가 window.M_TS_FORM.form 으로 내려준다(mWorkForm 과 달리 load() 없음).
// 타임시트는 접근권한자 전원 CRUD(SuitService 정책)라 수정 모드면 항상 삭제 가능.
// 루트 data-* 는 init() 에서만 읽는다. confirmDialog(바깥 스코프)와 이름이 겹치는 title/message 프로퍼티를 두지 말 것.
export default () => ({
    apiBase: '',
    wrSeq: '',
    backUrl: '/m/suit/list',
    performers: [],
    submitting: false,
    form: { wrGubun3: '', wrSubdate1: '', wrInfo1: '', wrContent: '' },

    init() {
        const d = this.$el.dataset;
        this.apiBase = d.api || '';
        this.wrSeq = d.seq || '';
        this.backUrl = d.back || '/m/suit/list';
        const boot = window.M_TS_FORM || {};
        this.performers = Array.isArray(boot.performers) ? boot.performers : [];
        if (boot.form) {
            this.form = Object.assign(this.form, boot.form);
        } else {
            const n = new Date();
            this.form.wrSubdate1 = n.getFullYear() + '-' + String(n.getMonth() + 1).padStart(2, '0') + '-' + String(n.getDate()).padStart(2, '0');
        }
    },

    get isEdit() { return !!this.wrSeq; },
    // 기존 값이 현재 수행자 목록에 없으면(삭제된 수행자) 맨 앞에 유지 — 데스크톱 options getter 미러
    get options() {
        const cur = this.form.wrGubun3;
        return (cur && !this.performers.includes(cur)) ? [cur].concat(this.performers) : this.performers;
    },

    async submit() {
        if (this.submitting) return;
        if (!this.form.wrSubdate1) {
            this.toast('warning', '입력 확인', '업무일을 입력하세요.');
            this.$refs.dateInput?.focus();
            return;
        }
        if (!this.form.wrGubun3) {
            this.toast('warning', '입력 확인', '업무수행자를 선택하세요.');
            this.$refs.performerInput?.focus();
            return;
        }
        const min = String(this.form.wrInfo1 == null ? '' : this.form.wrInfo1).trim();
        if (min !== '' && !/^[0-9]{1,7}$/.test(min)) {
            this.toast('warning', '입력 확인', '업무시간은 숫자(분)로 입력하세요.');
            this.$refs.minInput?.focus();
            return;
        }
        const label = this.isEdit ? '수정' : '등록';
        this.submitting = true;
        try {
            await this.$mapi(this.isEdit ? this.apiBase + '/' + this.wrSeq : this.apiBase, {
                method: this.isEdit ? 'PUT' : 'POST',
                body: { wrGubun3: this.form.wrGubun3, wrSubdate1: this.form.wrSubdate1, wrInfo1: min, wrContent: this.form.wrContent }
            });
            this.leave();
        } catch (e) {
            if (e.message === 'SESSION') return;
            this.toast('error', label + ' 실패', e.message || (label + ' 중 오류가 발생했습니다.'));
            this.submitting = false;
        }
    },

    // confirmDialog 콜백에서 호출 — 확인 자체는 템플릿의 confirm()(바깥 스코프)
    async remove() {
        if (this.submitting) return;
        this.submitting = true;
        try {
            await this.$mapi(this.apiBase + '/' + this.wrSeq, { method: 'DELETE' });
            this.leave();
        } catch (e) {
            if (e.message === 'SESSION') return;
            this.toast('error', '삭제 실패', e.message || '삭제 중 오류가 발생했습니다.');
            this.submitting = false;
        }
    },

    // 저장/삭제 후 복귀 — replace 로 폼을 히스토리에서 제거(뒤로가기 재진입·중복 저장 방지)
    leave() { window.location.replace(this.backUrl); },
    cancel() {
        if (window.history.length > 1) window.history.back();
        else window.location.href = this.backUrl;
    },

    toast(type, title, message) {
        window.dispatchEvent(new CustomEvent('show-toast', { detail: { type, title, message } }));
    }
});
